//#region src/translations/es_GT.json
var error = {
	"an_error_has_happened": "Ha ocurrido un error",
	"we_had_detected_an_error_please_try_again_later": "Hemos detectado un problema. Por favor inténtalo más tarde.",
	"accept": "Aceptar"
};
var back = { "go_back": "Regresar" };
var es_GT_default = {
	"not-found": {
		"this_page_went_flying": "Esta página se fue volando",
		"like_the_middle_payment": "(como la quincena 💸)",
		"go_to_the_start": "Regresar al principio"
	},
	error,
	"close-session": {
		"close_session_title": "¿Cerrar sesión?",
		"close_session_description": "¿Estás seguro que quieres cerrar sesión?",
		"close_session_subline": "Podrás iniciar sesión cuando quieras.",
		"close_session_confirm": "Sí, cerrar sesión",
		"close_session_cancel": "Volver",
		"close_session_error_message": "Ocurrió un error al cerrar sesión",
		"close_session_loading": "Cerrando sesión..."
	},
	"help-center": {
		"help_center_whatsapp": "WhatsApp",
		"help_center_email": "Correo electrónico"
	},
	back
};
//#endregion
export { back, es_GT_default as default, error };

//# sourceMappingURL=es_GT.js.map